var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "y-category-tree" },
    _vm._l(_vm.categories, function (child) {
      return _c("tree-menu", {
        key: child.name,
        attrs: {
          children: child.children,
          name: child.name,
          slug: child.full_slug,
          depth: 0,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }